import { FormSlug, ImplementationGuideFormData } from "../../types";
import { CardResource } from "../../types/CardResource.interface";
import { KeyTeamMembersFormData } from "../../types/ImplementationGuideFormData.interface";

const getFormResponsesForKeyTeamMembersSection = (
  data: Record<FormSlug, ImplementationGuideFormData>,
): CardResource[] => {
  const keyTeamMembersData = data[
    FormSlug.KeyTeamMembers
  ] as KeyTeamMembersFormData;

  if (keyTeamMembersData) {
    return keyTeamMembersData.contacts?.map((contact) => {
      return {
        resource_name: contact.Name,
        resource_subtitle: contact.roles.join(", "),
        todo_item: `${contact.Name} notified and aware of responsibilities`,
      };
    });
  } else {
    return [];
  }
};

export default getFormResponsesForKeyTeamMembersSection;
